import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

@Injectable()
export class NoAuthGuardService implements CanActivate {

    constructor(private _auth: AuthService, private _router: Router) { }

    async  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let resp = <boolean> await this._auth.isLogin().then((isLogin) => isLogin);
        if ( !resp ) {
            resp = true;
        } else {
            this._router.navigate(['/menu']);
            resp = false;
        }
        return resp;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/guards/no-auth-guard.service.ts